import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';

// Mirrors @screen-xs-max in shared/styles/breakpoints.less — keep the two in sync.
const PHONE_QUERY = '(max-width: 575px)';

export function useIsPhone(): Signal<boolean> {
    const breakpointObserver = inject(BreakpointObserver);
    return toSignal(
        breakpointObserver.observe([PHONE_QUERY]).pipe(map(r => r.matches)),
        { initialValue: false },
    );
}
